import { regexpConveyor } from 'shared-code/string'

export function htmlMapper<T extends string | null>(input: T): T {
  if (typeof input !== 'string') {
    return input
  }

  const html = input.replace(/<hr\s*>/gs, '<hr />')

  return regexpConveyor(html, [
    [/^(?:\s*<\/[^>]+>)+/gs, ''], // cut wrong wrapper ending tag in the beginning of content
    [/<[^/>]+>\s+$/gs, ''], // cut wrong wrapper start tag in the end of content
    [/^\s*<[^/>]+>$/gs, ''], // cut wrong unclosed tag in the end of content
    [/<(tr|td|table)[^>]*style[^>]*>/gs, '<$1>'], // removing inline table styles
    [
      /(<blockquote[^>]*?>)(.*?)<\/blockquote>/gs,
      (_match, _openTag, content) =>
        `<blockquote>${content.replace(/(<\/?)p/gs, '$1div')}</blockquote>`,
    ],
    [/<img /gs, '<img decoding="async" loading="lazy" '],
    [/<iframe /gs, '<iframe loading="lazy" '],
  ]) as T
}
